import '.i{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.o{justify-content:center;}.ssr-plugin'
import '.j{flex-direction:column;}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.by{flex-grow:1;}.ssr-plugin'
import '.k{align-items:center;}.ssr-plugin'
import '.b7{max-width:77.5rem;}.ssr-plugin'
import '.d7{justify-content:stretch;}.ssr-plugin'
import '.d8{position:sticky;}.ssr-plugin'
import '.cx{top:0;}.ssr-plugin'
import '.d9{z-index:10;}.ssr-plugin'
import '.da{padding-block:1rem;}.ssr-plugin'
import '.db{height:3rem;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.dc{flex-wrap:wrap;}.ssr-plugin'
import '.dd{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bg{margin-top:2rem;}.ssr-plugin'
import '.de{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="i ab o j co"
      >
        <div className="by i k o j"
        >
          <div className="b7 i j d7 d8 cx d9 co"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="da db i a3 k dc"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dd i j ab bg de b7"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
